import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { MapPinOff, Navigation, ShieldAlert, Loader2 } from 'lucide-react';

interface LocationPermissionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
  isChecking?: boolean;
  errorMessage?: string | null;
}

export const LocationPermissionModal: React.FC<LocationPermissionModalProps> = ({
  isOpen,
  onClose,
  onRetry,
  isChecking = false,
  errorMessage,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md p-6 bg-white rounded-2xl border border-red-100 shadow-2xl">
        <DialogHeader className="flex flex-col items-center text-center space-y-3">
          <div className="w-14 h-14 rounded-full bg-red-100 text-red-600 flex items-center justify-center animate-pulse">
            <MapPinOff size={30} />
          </div>
          <DialogTitle className="text-xl font-bold text-gray-900">
            Autorização de Localização Obrigatória
          </DialogTitle>
          <DialogDescription className="text-sm text-gray-600 space-y-2">
            <p>
              {errorMessage ||
                'A autorização de acesso à localização do dispositivo é obrigatória para iniciar e executar a pesquisa.'}
            </p>
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 text-xs text-amber-800 flex items-start gap-2 text-left">
              <ShieldAlert size={18} className="shrink-0 text-amber-600 mt-0.5" />
              <span>
                Por favor, habilite a permissão de localização no seu navegador/dispositivo para prosseguir.
              </span>
            </div>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex flex-col sm:flex-row gap-2 mt-4">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isChecking}
            className="w-full sm:w-1/2 text-xs h-10 border-gray-300"
          >
            Cancelar
          </Button>

          <Button
            onClick={onRetry}
            disabled={isChecking}
            className="w-full sm:w-1/2 text-xs h-10 bg-red-600 hover:bg-red-700 text-white font-bold gap-2"
          >
            {isChecking ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                Verificando...
              </>
            ) : (
              <>
                <Navigation size={16} />
                Permitir Localização
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LocationPermissionModal;
